import * as tslib_1 from "tslib";
import styled from 'styled-components';
import DialogTitle from './DialogTitle';
import Typography from '../Typography';
// 提示框内容
var DialogContent = styled(Typography).attrs({
    type: 'subheading',
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 24px 24px 24px 24px;\n  color: ", ";\n  overflow-y: auto;\n  flex: 1 1 auto;\n  ", " ~ & {\n    padding-top: 0;\n  }\n"], ["\n  padding: 24px 24px 24px 24px;\n  color: ", ";\n  overflow-y: auto;\n  flex: 1 1 auto;\n  ", " ~ & {\n    padding-top: 0;\n  }\n"])), function (props) { return props.theme.palette.text[props.color || 'secondary']; }, DialogTitle);
export default DialogContent;
var templateObject_1;
//# sourceMappingURL=DialogContent.js.map